export const GET_LANGUAGE = "GET_LANGUAGE";
export const GET_SINGLE_LANGUAGE = "GET_SINGLE_LANGUAGE";
export const CREATE_LANGUAGE = "CREATE_LANGUAGE";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const DELETE_LANGUAGE = "DELETE_LANGUAGE";
export const TOGGLE_LANGUAGE = "TOGGLE_LANGUAGE";

export const GET_TRANSLATION = "GET_TRANSLATION";
export const UPDATE_TRANSLATION = "UPDATE_TRANSLATION";
export const UPLOAD_TRANSLATION = "UPLOAD_TRANSLATION";
export const DOWNLOAD_TRANSLATION = "DOWNLOAD_TRANSLATION";

export const OPEN_LANGUAGE_DIALOG = "OPEN_LANGUAGE_DIALOG";
export const CLOSE_LANGUAGE_DIALOG = "CLOSE_LANGUAGE_DIALOG";